import styled from '@emotion/styled'
import { Button, ButtonProps } from '@mui/material'

interface GradientBorderedButtonProps extends ButtonProps {
    isThisSelected?: boolean;
    radius?: string;
}

const GradientBorderedButton = styled(Button)<GradientBorderedButtonProps>(({ isThisSelected = false, radius = '16px' }) => ({
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'flex-start',
    paddingX: 2,
    color: 'var(--text-dark)',
    textTransform: 'none',
    borderRadius: radius,
    boxShadow: '0px 0px 9px 0px rgba(18, 174, 181, 0.86) inset',
    border: '2px solid #00A9B1',
    background: '#F2F8FD',
}))

export default GradientBorderedButton